/* eslint-disable max-len */
import React from 'react';

const NoPayments: React.FC<object> = () => {
    return (
        <svg width="228" height="228" viewBox="0 0 228 228" fill="none" xmlns="http://www.w3.org/2000/svg">
            <g filter="url(#filter0_d_16202_191305)">
                <g clipPath="url(#clip0_16202_191305)">
                    <path d="M52.5 138.223L52.5 50C52.5 40.335 60.335 32.5 70 32.5L158 32.5C167.665 32.5 175.5 40.335 175.5 50L175.5 138C175.5 147.665 167.665 155.5 158 155.5L151.333 155.5C149.011 155.5 146.889 154.188 145.851 152.111L145.718 151.846C141.439 143.288 129.227 143.288 124.948 151.846L124.815 152.111C123.777 154.188 121.655 155.5 119.333 155.5L108.964 155.5C106.46 155.5 104.172 154.085 103.052 151.846C98.7731 143.288 86.561 143.288 82.2822 151.846C81.1625 154.085 78.873 155.5 76.3691 155.5L69.7773 155.5C60.2355 155.5 52.5 147.765 52.5 138.223Z" stroke="#1DB5B6" strokeWidth="5"/>
                    <path d="M76.6667 94L151.333 94" stroke="#1DB5B6" strokeWidth="5" strokeLinecap="round"/>
                    <path d="M76.6667 115.333L151.333 115.333" stroke="#1DB5B6" strokeWidth="5" strokeLinecap="round"/>
                    <path d="M76.6667 67.3333H108.667" stroke="#1DB5B6" strokeWidth="5" strokeLinecap="round"/>
                </g>
            </g>
            <defs>
                <filter id="filter0_d_16202_191305" x="0" y="0" width="228" height="228" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
                    <feFlood floodOpacity="0" result="BackgroundImageFix"/>
                    <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
                    <feOffset dy="20"/>
                    <feGaussianBlur stdDeviation="25"/>
                    <feComposite in2="hardAlpha" operator="out"/>
                    <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.05 0"/>
                    <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_16202_191305"/>
                    <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_16202_191305" result="shape"/>
                </filter>
                <clipPath id="clip0_16202_191305">
                    <rect width="128" height="128" fill="white" transform="translate(50 30)"/>
                </clipPath>
            </defs>
        </svg>
    );
};

export default NoPayments;